import React from "react";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import Support2 from "./support2";

const Support = () => {
  return (
    <>
      <Header />
      <Support2/>
      <Footer />
    </>
  );
};

export default Support;
